import * as React from "react";
import {useNavigate} from "react-router-dom";
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import {Helmet} from "react-helmet";
import API from "../../api";
import {useEffect, useState} from "react";
import moment from "moment";
import RichText from "../../components/RichText";
import CommentEditor from "../../components/CommentEditor";
import {normalizeQuillHtml, richTextHasText} from "../../components/QuillInput";

import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import ProfileImage from "../../components/ProfileImage";
import {Button, Offcanvas} from "react-bootstrap";
import {useAuth} from "../../AuthUser";


function LessonComments() {
	let auth = useAuth();
	let navigate = useNavigate();

	const [lessonComments, setLessonComments] = useState([])
	const [isLoading, setLoading] = useState(false)
	const [isSubmitting, setSubmitting] = useState(false)
	const [show, setShow] = useState(false);
	const [comment, setComment] = useState([])
	const [disabled, setDisabled] = useState(false);
	const [text, setText] = useState('');
	const handleClose = () => setShow(false);
	const handleShow = (e,comment) => {
		e.preventDefault()
		setComment(comment);
		setShow(true);
	}

	useEffect(() => {
		setLoading(true);
		API.get("admin/lessonComments")
			.then(response => setLessonComments(response.data))
			.finally(() => setLoading(false));
	}, [])

	const handleSubmit = (e) => {
		e.preventDefault();
		// "<p><br></p>" is what an empty Quill document serializes to, so a
		// truthy check would post blank replies.
		if (richTextHasText(text)) {
			setSubmitting(true);
			API.post(`lessonComments/${comment.review_id}`, {
				// Quill emits &nbsp; for every space; normalize on submit only.
				comment: normalizeQuillHtml(text),
				bodyFormat: 'html',
				creator: auth.user.id,
				parentId: comment.id,
			})
				.then((response) => {
					navigate(0);
				})
				.finally(() => {
					setSubmitting(false);
					handleClose()
					setText('');
					}
				);
		}
	}
	const onRowSelect = (event) => {
			navigate(`/lesson/${event.data.review_id}`)
			setShow(true);
			setComment(event.data);
			setText('')
	};

	const instructorTemplate = (comment) => {
		return <span>{comment?.instructor_first_name || ''} {comment?.instructor_last_name || ''}</span>
	}

	const lessonCommentTemplate = (comment) => {
		return <>
			<div className='`comments'>
			<div className="d-flex flex-row p-3 gap-3">
				<ProfileImage size={40} textSizeRatio={2.75} text={comment.email}/>
				<div className="w-100">
					<div className="d-flex justify-content-between align-items-center">
						<div className="d-flex flex-row align-items-center">
							<span className="me-2 text-capitalize">{comment?.first_name || ''} {comment?.last_name || ''}  &#x2022; <small>{moment(comment.created_at).fromNow()}</small> &#x2022; <a href={`/lesson/${comment.review_id}`}><i className="fa fa-arrow-up-right-from-square"/> </a> </span>
						</div>

					</div>

					<div className="text-justify comment-text mb-0"><RichText text={comment.comment} format={comment.bodyFormat}/></div>
					<div className="d-flex flex-row gap-1">
							<a href="#" className="ms-3 small text-decoration-none"
							   onClick={e => handleShow(e, comment)}><strong>Reply</strong></a>
					</div>
					{''}
				</div>
			</div>
		</div>
		</>
	}

	return (
		<>
			<Helmet>
				<title>Lesson Comments | MyGolfDNA.com</title>
				<meta name="description" content="Categories"/>
			</Helmet>
			<div className="mt-4">
				<Row>
					<Col>
						<h2>Lesson Comments</h2>
						<div className="card">
							<DataTable
								value={lessonComments}
								paginator rows={50}
								rowsPerPageOptions={[50, 100, 200]}
								tableStyle={{ minWidth: '50rem' }}
								selectionMode="single"
								//onRowSelect={onRowSelect}
							>
								<Column field="comment" header="Comment" body={lessonCommentTemplate}/>
								<Column field="instructor_first_name" sortable header="Instructor"/>
							</DataTable>
						</div>
					</Col>
				</Row>
			</div>
			<Offcanvas className="offcanvas-backdrop-blue" show={show} onHide={handleClose} placement="bottom" backdrop="static" scroll={true}>
				<Offcanvas.Body>
					<div className="text-justify comment-text"><RichText text={comment.comment} format={comment.bodyFormat}/></div>
					<form className="" onSubmit={handleSubmit}>
						<div className="d-flex flex-row align-items-center gap-3">
							<CommentEditor value={text} onChange={setText} placeholder="Enter your comment..." readOnly={disabled}/>
						</div>
						<div className="d-flex flex-row mt-2 float-end gap-2">
							<Button size="sm" variant="danger" onClick={handleClose}>Close</Button>
							<Button size="sm" variant="primary" type="submit" disabled={disabled}>
								{isSubmitting ? (
									<>
													<span
														className="spinner-border spinner-border-sm"
														role="status"
														aria-hidden={true}
													/>{" "}
									</>
								) : (
									"Comment"
								)}
							</Button>
						</div>
					</form>
				</Offcanvas.Body>
			</Offcanvas>
		</>
	);
}

export default LessonComments;
